module.exports = __webpack_public_path__ + "img/Website logo bar (Chi)-01.9c5a92ce.jpg";